import PropTypes from 'prop-types';
import React from 'react';
import { Button, Image } from 'react-bootstrap';


class RoomPhoto extends React.Component {
	constructor(props) {
		super(props)
	}


	handleRemovePhoto = () => {
		this.props.removeRoomPhoto(this.props.room_photo.id, this.props.room_type_id)
	}

	render() {
		const room_photo = this.props.room_photo;
		return (
			<div className="col-sm-3 col-md-3">
				<div className="thumbnail">
					<Image src={room_photo.photo} responsive />
					<div><Button onClick={this.handleRemovePhoto} title="Remove"><i className="fa fa-trash" /></Button></div>
				</div>
			</div>
		);
	}
}

export default RoomPhoto;



// WEBPACK FOOTER //
// src/routes/hotels/components/RoomPhoto.js